// src/temas/temas-config.ts
export const TEMAS_APP = {
  MODERNO_BLUE: { 
    primary: '#2563eb', 
    secondary: '#60a5fa', 
    background: '#f8fafc', 
    surface: '#ffffff', 
    text: '#1e293b' 
  },
  ELEGANT_GOLD: { 
    primary: '#846733', 
    secondary: '#c5a059', 
    background: '#fafaf9', 
    surface: '#ffffff', 
    text: '#1c1917' 
  },
  NATURE_GREEN: { 
    primary: '#166534', 
    secondary: '#4ade80', 
    background: '#f0fdf4', 
    surface: '#ffffff', 
    text: '#14532d' 
  },
  VIBRANT_PURPLE: { 
    primary: '#7c3aed', 
    secondary: '#a78bfa', 
    background: '#f5f3ff', 
    surface: '#ffffff', 
    text: '#2e1065' 
  },
  SOFT_ROSE: { 
    primary: '#e11d48', 
    secondary: '#fb7185', 
    background: '#fff1f2', 
    surface: '#ffffff', 
    text: '#4c0519' 
  },
  // NOVO TEMA: Preto e Branco (Dark)
  // Estética Vintage/Industrial: Couro, Madeira e Metal
  BARBER_CLASSIC: {
    primary: '#451a03',    // Marrom Couro/Madeira Escura
    secondary: '#92400e',  // Bronze/Âmbar
    background: '#fefaf6', // Off-white papel envelhecido
    surface: '#ffffff',
    text: '#1c1917'
  },

  // Estética Noir/Luxo: Preto e Ouro (Muito comum em barbearias premium)
  BARBER_PREMIUM: {
    primary: '#171717',    // Preto Profundo (Matte)
    secondary: '#b45309',  // Dourado Envelhecido / Cobre
    background: '#fafaf9', // Fundo Neutro
    surface: '#ffffff',
    text: '#0a0a0a'
  },

  // Estética Urban/Modern: Tons de Cinza e Azul Petróleo (Estilo Industrial Moderno)
  BARBER_URBAN: {
    primary: '#0f172a',    // Azul Navy/Slate Escuro
    secondary: '#64748b',  // Cinza Azulado (Aço)
    background: '#f1f5f9', // Fundo Cinza Claro
    surface: '#ffffff',
    text: '#0f172a'
  },

  // Ajustando seu DARK_MINIMAL para ser realmente Dark
  DARK_MINIMAL: { 
    primary: '#fafafa',    // Destaques em Branco
    secondary: '#a1a1aa',  
    background: '#09090b', // Fundo quase preto
    surface: '#18181b',    // Cards um pouco mais claros que o fundo
    text: '#ececf4' 
  }
} as const;

export type ThemeType = keyof typeof TEMAS_APP;